// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add_to_folder_add_button-module__label--1MkoM{margin-left:5px;vertical-align:top}.add_to_folder_add_button-module__button--38vVM{margin-right:10px;max-width:100%;margin-bottom:12px}\n", ""]);
// Exports
exports.locals = {
	"label": "add_to_folder_add_button-module__label--1MkoM",
	"button": "add_to_folder_add_button-module__button--38vVM"
};
module.exports = exports;
